import {
  createRouter,
  createWebHashHistory
} from 'vue-router'
import home from '../views/home.vue' //首页
import login from '../views/login.vue' //登录
import registered from '../views/registered.vue' //注册
import contentChain from '../views/contentChain.vue' //内容上链
import homeStartingPage from '../views/startingPage.vue' //主页
import homeArticleManagement from '../views/homeArticleManagement.vue' //文章管理
import articleDetails from '../views/articleDetails.vue' //上链文章详情
import homePage from '../views/homePage.vue' //上链文章详情
import roductPricing from '../views/roductPricing.vue' //定价
import pricingSuccessful from '../views/pricingSuccessful.vue' //定价成功
import orderManagement from '../views/orderManagement.vue' //订单管理
import agreementPage from '../views/agreementPage.vue' //协议页面
import cashManagement from '../views/cashManagement/index.vue' //提现页面
import withdrawalSetting from '../views/cashManagement/withdrawalSetting.vue' //提现页面
import invoiceManagement from '../views/invoiceManagement/index.vue' //提现页面
import invoiceManagementSetting from '../views/invoiceManagement/setting.vue' //提现页面
import copyrightConfirmationRegistration from '../views/staticPage/copyrightConfirmationRegistration.vue'
import buyCopyright from '../views/staticPage/buyCopyright.vue'
import copyrightHelpCentre from '../views/staticPage/copyrightHelpCentre.vue'
import intelligentContribute from '../views/staticPage/intelligentContribute.vue'
import rightsProtectionService from '../views/staticPage/rightsProtectionService.vue'
import accountManagement from '../views/accountManagement.vue' //账号详情
import accountSettings from '../views/accountSettings.vue' //账号认证

import copyrightExport from '../views/copyrightExport/index.vue'
import copyrightExportLog from '../views/copyrightExport/log.vue'
import copyrightExportLogDetail from '../views/copyrightExport/logDetail.vue'
import Cookies from "js-cookie";

const routes = [{
  path: '/',
  name: 'home',
  component: home,
  redirect: 'homeStartingPage',
  children: [
    {
      path: 'invoiceManagementSetting',
      name: 'invoiceManagementSetting',
      component: invoiceManagementSetting
    },
    {
      path: 'cashManagement',
      name: 'cashManagement',
      component: cashManagement
    },
    {
      path: 'invoiceManagement',
      name: 'invoiceManagement',
      component: invoiceManagement
    },
    {
      path: 'withdrawalSetting',
      name: 'withdrawalSetting',
      component: withdrawalSetting
    },
    {
      path: 'homeStartingPage',
      name: 'homeStartingPage',
      component: homeStartingPage
    },
    {
      path: 'homeArticleManagement',
      name: 'homeArticleManagement',
      component: homeArticleManagement,
    },
    {
      path: 'copyrightExport',
      name: 'copyrightExport',
      component: copyrightExport,
    },
    {
      path: 'copyrightExportLog',
      name: 'copyrightExportLog',
      component: copyrightExportLog,
    },
    {
      path: 'copyrightExportLogDetail',
      name: 'copyrightExportLogDetail',
      component: copyrightExportLogDetail,
    },
    {
      path: 'roductPricing',
      name: 'roductPricing',
      component: roductPricing
    },
    {
      path: 'pricingSuccessful',
      name: 'pricingSuccessful',
      component: pricingSuccessful
    },
    {
      path: 'orderManagement',
      name: 'orderManagement',
      component: orderManagement
    },
    {
      path: '/accountManagement',
      name: 'accountManagement',
      component: accountManagement
    },
    {
      path: '/accountSettings',
      name: 'accountSettings',
      component: accountSettings
    }
  ]
},
{
  path: '/homePage',
  name: 'homePage',
  component: homePage
},
{
  path: '/login',
  name: 'login',
  component: login
},
{
  path: '/registered',
  name: 'registered',
  component: registered
},
{
  path: '/contentChain',
  name: 'contentChain',
  component: contentChain
},
{
  path: '/articleDetails',
  name: 'articleDetails',
  component: articleDetails
},
{
  path: '/agreementPage',
  name: 'agreementPage',
  component: agreementPage
},
{
  path: '/copyrightConfirmationRegistration',
  name: 'copyrightConfirmationRegistration',
  component: copyrightConfirmationRegistration
},
{
  path: '/buyCopyright',
  name: 'buyCopyright',
  component: buyCopyright
},
{
  path: '/copyrightHelpCentre',
  name: 'copyrightHelpCentre',
  component: copyrightHelpCentre
},
{
  path: '/intelligentContribute',
  name: 'intelligentContribute',
  component: intelligentContribute
},
{
  path: '/rightsProtectionService',
  name: 'rightsProtectionService',
  component: rightsProtectionService
}
]



const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, form, next) => {
  if (to.path === '/login' || to.path === '/registered' || to.path === '/homePage' || to.path === '/agreementPage' || to.path === '/copyrightConfirmationRegistration' || to.path === '/intelligentContribute' || to.path === '/rightsProtectionService' || to.path === '/copyrightHelpCentre' || to.path === '/buyCopyright') return next();
  const tokenstr = Cookies.get("userInformation") || ''
  if (!tokenstr) return next('/homePage');
  next();
})
export default router
